import { createFileRoute } from '@tanstack/react-router'
import { LegacyMatchAliasRecovery } from '~/features/football-match-detail/football-match-detail'
import { loadLegacyMatchAliasRoute } from '~/features/football-match-detail/legacy-route-options'
import { handleLegacyMatchAliasRequest } from '~/features/football-match-detail/legacy-server-handler'

export const Route = createFileRoute('/$locale/radar/events/$eventId')({
  server: {
    handlers: {
      GET: ({ request, params }) => handleLegacyMatchAliasRequest({
        request,
        sourceKind: 'polymarket_event',
        sourceId: params.eventId,
        locale: params.locale === 'zh-CN' ? 'zh-CN' : 'en',
      }),
    },
  },
  loader: ({ params, location }) => loadLegacyMatchAliasRoute({
    sourceKind: 'polymarket_event',
    sourceId: params.eventId,
    locale: params.locale === 'zh-CN' ? 'zh-CN' : 'en',
    location,
  }),
  component: LocalizedRadarEventLegacyRoute,
  notFoundComponent: () => <LegacyMatchAliasRecovery locale="zh-CN" kind="not_found" />,
})

function LocalizedRadarEventLegacyRoute() {
  const { locale } = Route.useParams()
  const state = Route.useLoaderData()
  return (
    <LegacyMatchAliasRecovery
      locale={locale === 'zh-CN' ? 'zh-CN' : 'en'}
      kind={state.kind}
    />
  )
}
